import { QUERY_CHANGE } from "./const";

function action(name, value, valueBeforeSuggest = "") {
  return {
    type: QUERY_CHANGE,
    name,
    value,
    valueBeforeSuggest,
  };
}

export default action;
